<template>
  <Modal
    :title="title"
    :width="width"
    v-model="showDialog"
    :mask-closable="false"  sticky reset-drag-position
    @on-visible-change="closeDialog" :mask="false" draggable
  >
    <div style="height: 200px">
      <div>
        <label class="prefix"><span style="color: red">*</span>
          文件名称：
        </label>
        <el-input class="suffix" v-model="fileData.rwsfName" size="small" placeholder="限制30个字符" :maxlength="30"></el-input>
      </div>
      <div class="add_ivr single_edit_add">
        <label class="prefix"><span style="color: red" v-show="hasFileShow">*</span>
          语音文件：
        </label>
        <div class="single_input upload-file">
          <Upload :action="uploadUrl" :show-upload-list="showUploadList" :on-success="handleSuccessVoiceType" :on-error="handleFail" :format="format" :max-size="1024*1024*15">
            <img src="../../../assets/image/upload.png" title="语音文件上传">
          </Upload>
          <div class="img_div"><img src="../../../assets/image/audition.png" title="试听"  @click="playVoiceFile(voiceFile)"></div>
        </div>
      </div>
      <div>
        <label class="prefix">
          文件简介：
        </label>
        <el-input v-model="fileData.rwsfDescr" size="small" type="textarea" class="suffix" :rows="5" resize="none"></el-input>
      </div>
    </div>
    <!--页脚-->
    <div slot="footer">
      <el-button type="primary" @click.prevent="submit" size="small">确定</el-button>
      <el-button @click="showDialog=false" size="small">取消</el-button>
    </div>
    <playMusicPop  @closeRecordfile="closeRecordfile" :showRecordFile="showRecordFile" :recordFile="recordFile"></playMusicPop>
  </Modal>
</template>

<script>
  import playMusicPop from '@/components/statisticsReportForm/detailedReportForm/PlayMusicPop.vue'
  export default {
    name: "FileDialog",
    components:{
      playMusicPop
    },
    props: ['fileId','show','isEdit','flowId'],
    data() {
      return {
        title: '新增语音文件',
        width: 400,
        uploadUrl:this.baseURL+"common/upload.json?type=customizeMusic&companyNo="+localStorage.getItem("companyId"),
        showUploadList:false,
        format:['mp3','wav'],
        showDialog: false,
        hasFileShow:true,
        fileData: {id:'',rwsfName:'',rwsfPath:'',rwsfDescr:'',rwId:''},
        recordFile: null,
        voiceFile: null,
        showRecordFile: false
      }
    },
    methods:{
      closeDialog(val) {
        this.$emit('close',val)
      },
      submit() {
        let param = {}
        let that = this
        Object.assign(param,this.fileData)
        param.rwsfPath = this.voiceFile
        param.rwId = this.flowId
        if (!param.rwsfName) {
          this.$Modal.info({
            title:'提示',
            content:'文件名称不能为空'
          })
          return
        }
        if (!param.rwsfPath) {
          this.$Modal.info({
            title:'提示',
            content:'文件不能为空'
          })
          return
        }
        if (this.isEdit) {
          param.menuId = 'a_2-8'
          param.journalType = 'AI机器人管理=>流程绘制=>编辑语音文件'
          this.$http.post('/AI/FlowDetail/updateFile',param).then(res=>{
            let response = res.data
            if (response.flag != '666') {
              that.$alert(response.msg,'提示',{
                confirmButtonText: '确定'
              })
              return false
            }
            this.$Message.success("编辑语音文件成功")
            this.showDialog = false
          });
        } else {
          param.menuId = 'a_2-8'
          param.journalType = 'AI机器人管理=>流程绘制=>添加语音文件'
          this.$http.post('/AI/FlowDetail/addFile',param).then(res=>{
            let response = res.data
            if (response.flag != '666') {
              that.$alert(response.msg,'提示',{
                confirmButtonText: '确定'
              })
              return false
            }
            this.$Message.success("新增语音文件成功")
            this.showDialog = false
          })
        }
      },
      initData(fileId) {
        let param = {id:fileId,rwId:this.flowId}
        let that = this
        this.$http.post("/AI/FlowDetail/queryFile",param).then(res=>{
          let response = res.data
          if (response.flag != '666') {
            that.$alert(response.msg,'提示',{
              confirmButtonText: '确定'
            })
            return false
          }
          this.fileData = response.obj
          if (this.fileData.rwsfDescr == null) {
            this.fileData.rwsfDescr = ''
          }
          this.voiceFile = response.obj.rwsfPath;
          this.hasFileShow = true
          if (this.voiceFile) {
            this.hasFileShow = false
          }
        })
      },
      handleSuccessVoiceType(res,file) {
        this.$Modal.info({
          title:'提示',
          content:res.msg
        });
        this.voiceFile=file.response.obj.absolutePath;
      },
      handleFail(error,file) {
        this.$Modal.info({
          title:'失败提示',
          content:file.response.msg
        });
      },
      playVoiceFile(recordFile) {
        if(!recordFile){
          this.$Modal.info({
            title:'提示',
            content:"语音文件不存在"
          });
          return false;
        }
        this.showRecordFile=true;
        this.recordFile=this.baseImgURL+recordFile;
      },
      closeRecordfile() {
        this.showRecordFile=false;
      }
    },
    watch:{
      isEdit:{
        deep:true,
        handler(val) {
          if (val) {
            this.title = '编辑语音文件'
          } else {
            this.title = '新增语音文件'
          }
        }
      },
      show:{
        deep:true,
        immediate:true,
        handler(val) {
          this.showDialog = val
          if (val) {
            if (this.fileId) {
              this.initData(this.fileId);
            } else {
              this.fileData = {id:'',rwsfName:'',rwsfPath:'',rwsfDescr:'',rwId:''}
              delete this.voiceFile
              this.voiceFile = null
              this.hasFileShow = true
            }
          }
        }
      }
    }
  }
</script>

<style lang="css">
  .prefix{
    width: 25%;
    text-align: right;
    float: left;
    line-height: 32px;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .suffix{
    width: 65%;
    float: left;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .upload-file{
    width: 65%!important;
    margin-top: 5px;
    margin-bottom: 5px;
    padding-top: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/flow/components/FileDialog.vue